/* globals $ */

/**
 * class for the handling navbar actions
 */
class NavBar {
  init() {
    if (typeof $ === 'undefined') return;
    this.handleWindowScrollAndUpdateNavDropdownPosition();
    this.collapseHoverAndClickOutside();
  }

  // Navbar V3 scripts

  /**
   * jQuery to collapse the navbar on scroll
   * Also handles nav dropdown positioning on desktop.
   * To make sure that we trap the `focus` when pressing tab,
   * opted to use `position-fixed` instead of `position-absolute` to add
   * the dropdown next to its trigger.
   */
  handleWindowScrollAndUpdateNavDropdownPosition() {
    const navbarHeightOffset = 64;

    function handleUpdateDropdownMenuPosition(appSwitcher, navBannerOffset) {
      const switcherTop = Math.abs(appSwitcher?.get(0)?.getBoundingClientRect()?.top);
      const switcherHeight = appSwitcher.height();
      const switcherOffset = switcherTop === 0 ? switcherHeight : 0;
      if ($('.navbar-v3').length && window.scrollY > 10) {
        $('.navbar-v3').addClass('shadow');
        $('.nav-desktop-menu').each((__, el) => {
          $(el).css('top', navbarHeightOffset + navBannerOffset);
        });
      } else if (window.scrollY === 0) {
        $('.navbar-v3').removeClass('shadow');
        $('.nav-desktop-menu').each((__, el) => {
          $(el).css('top', navbarHeightOffset + navBannerOffset + switcherOffset);
        });
      }
    }
    $(() => {
      // check if nav banner is visible
      const navBanner = $('#external-nav-banner-for-goprofiles');
      const navBannerHeight = navBanner?.outerHeight(true) ?? 0;
      const navBannerOffset = navBannerHeight && navBannerHeight > 3 ? navBannerHeight : 0;

      // Get the app switcher's height and/or check if it's visible
      const appSwitcher = $('#ExternalAppSwitcher');

      // Update initial position of dropdown.
      $('.nav-desktop-menu').each(() => {
        handleUpdateDropdownMenuPosition(appSwitcher, navBannerOffset);
      });

      // Listen to scroll event and update dropdown menu positioning
      $(window).on('scroll', () => {
        handleUpdateDropdownMenuPosition(appSwitcher, navBannerOffset);
      });

      // Update menu dropdown position again when banner is dismissed
      $('#external-nav-banner-for-goprofiles-dismiss-button').on('click', () => {
        $(window).off('scroll');
        handleUpdateDropdownMenuPosition(appSwitcher, 0);
        setTimeout(() => {
          // Turn on scroll again
          $(window).on('scroll', () => {
            handleUpdateDropdownMenuPosition(appSwitcher, 0);
          });
        }, 100);
      });
    });
  }

  collapseHoverAndClickOutside() {
    $(() => {
      // Bootstrap's collapse plugin may not be available in all page contexts
      if (!$.fn.collapse) {
        return;
      }

      const toggles = $('.nav-dropdown-desktop-toggle');
      const desktopWrappers = $('.nav-desktop-menu');
      let timeout;
      // Track mouseenter events. opted to use `mouseenter` vs `mouseover` to prevent it from triggering the callback whenever mouse moves inside this element. See:  https://javascript.info/mousemove-mouseover-mouseout-mouseenter-mouseleave
      toggles.on('mouseenter focus', event => {
        clearTimeout(timeout);
        const target = $(event.currentTarget);
        const id = target.attr('data-target');
        $(id).collapse('show');
      });

      // Also track when mouse enters the dropdown menu itself
      desktopWrappers.on('mouseenter focus', event => {
        // Clear the timeout, helpful especially when we queue to collapse the menu.
        clearTimeout(timeout);
        const id = `#${event.currentTarget.id}`;
        $(id).collapse('show');
      });

      // Track when it leaves the element
      toggles.on('mouseleave', event => {
        clearTimeout(timeout);
        const target = $(event.currentTarget);
        const id = target.attr('data-target');
        timeout = setTimeout(() => {
          $(id).collapse('hide');
        }, 250);
      });

      desktopWrappers.on('mouseleave blur', event => {
        // Clear the timeout, helpful especially when we queue to collapse the menu.
        clearTimeout(timeout);
        const id = `#${event.currentTarget.id}`;
        timeout = setTimeout(() => {
          $(id).collapse('hide');
        }, 250);
      });

      // Mobile Events
      /**
       * See https://getbootstrap.com/docs/4.6/components/collapse/#events for event reference
       */
      $('#nav-mobile-dropdown').on('show.bs.collapse', event => {
        // Prevent overflow scroll when dropdown menu is visible
        if (event.target === $('#nav-mobile-dropdown').get(0)) {
          $('body').css('overflow', 'hidden');
          /**
           * Get the visible height of the app switcher
           */
          const appSwitcher = $('#ExternalAppSwitcher');
          const appSwitcherTop = Math.abs(appSwitcher.get(0).getBoundingClientRect().top);
          const appSwitcherHeight = appSwitcher.height();

          const appSwitcherOffset = appSwitcherTop <= appSwitcherHeight ? appSwitcherHeight - appSwitcherTop : 0;

          /**
           * Get the height of external banner if visible
           */
          const navBanner = $('#external-nav-banner-1');
          const navBannerHeight = navBanner?.outerHeight(true) ?? 0;

          const deviceHeight = $(window).height();
          const navbarHeight = 60; // not reflective of the actual height, just wanted to add additional offset.
          const expandedMenuHeight = deviceHeight - navbarHeight - appSwitcherOffset - navBannerHeight;
          const wrapper = event.currentTarget.firstElementChild;
          $(wrapper).css('height', `${expandedMenuHeight}px`);
        }
      });

      $('#nav-mobile-dropdown').on('hidden.bs.collapse', event => {
        if (event.target === $('#nav-mobile-dropdown').get(0)) {
          $('body').css('overflow', '');
        }
      });
    });
  }
}

export default NavBar;
